import Header from './fragment-sample/header.js';
import Navi from './fragment-sample/navi.js';

const SampleLayout = ({ children }) => (
	<div>
		<Header />
		<Navi />
		<main>{children}</main>
	</div>
);

export default SampleLayout;
